<template>
  <div
    class="sidebar-modern"
    :style="sidebarPalette"
    v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
    <v-layout wrap>
      <v-flex>
        <section class="sidebar-section">

          <div class="sidebar-widget">
            <v-card flat class="sidebar-card">
              <v-card-text class="sidebar-card-text">
                <div class="sidebar-widget-title" :style="{ color: set_color }">
                  <v-icon small class="mr-1">mdi-shield-alert-outline</v-icon>
                  Rumah Hoax dan Insiden Siber
                </div>
                <v-divider class="sidebar-divider mb-0 mt-2"></v-divider>
                <div v-for="(item, index) in process.load ? 8 : hoax" :key="'hoax-' + index">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="list-item-three-line">
                    <div v-show="!process.load && hoax.length > 0">
                      <nuxt-link
                        :to="`/rumah-hoax-dan-insiden-siber/${item.slug}?q=${item.id}`"
                        class="sidebar-link"
                        @mouseover.native="voiceHover(item.title)">
                        <span class="sidebar-link-num">{{ index + 1 }}</span>
                        <span class="sidebar-link-title">{{ item.title }}</span>
                      </nuxt-link>
                      <v-divider v-if="index < hoax.length - 1" class="sidebar-item-divider"></v-divider>
                    </div>
                  </v-skeleton-loader>
                </div>
              </v-card-text>
            </v-card>
          </div>

          <div class="sidebar-widget">
            <v-card flat class="sidebar-card">
              <v-card-text class="sidebar-card-text">
                <div class="sidebar-widget-title" :style="{ color: set_color }">
                  <v-icon small class="mr-1">mdi-newspaper-variant-multiple-outline</v-icon>
                  Berita Terbaru
                </div>
                <v-divider class="sidebar-divider mb-0 mt-2"></v-divider>
                <div v-for="(item, index) in process.load ? 8 : list" :key="'list-' + index">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="list-item-three-line">
                    <div v-show="!process.load && list.length > 0">
                      <nuxt-link
                        :to="`/berita/${item.slug}?q=${item.id}`"
                        class="sidebar-link"
                        @mouseover.native="voiceHover(item.title)">
                        <span class="sidebar-link-num">{{ index + 1 }}</span>
                        <span class="sidebar-link-title">{{ item.title }}</span>
                      </nuxt-link>
                      <v-divider v-if="index < list.length - 1" class="sidebar-item-divider"></v-divider>
                    </div>
                  </v-skeleton-loader>
                </div>
              </v-card-text>
            </v-card>
          </div>

          <div class="sidebar-widget">
            <v-card flat class="sidebar-card">
              <v-card-text class="sidebar-card-text">
                <div class="sidebar-widget-title" :style="{ color: set_color }">
                  <v-icon small class="mr-1">mdi-star-outline</v-icon>
                  Berita Terpilih
                </div>
                <v-divider class="sidebar-divider mb-0 mt-2"></v-divider>
                <div v-for="(item, index) in process.load ? 8 : highlight" :key="'highlight-' + index">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="list-item-three-line">
                    <div v-show="!process.load && highlight.length > 0">
                      <nuxt-link
                        :to="`/berita/${item.slug}?q=${item.id}`"
                        class="sidebar-link"
                        @mouseover.native="voiceHover(item.title)">
                        <span class="sidebar-link-num">{{ index + 1 }}</span>
                        <span class="sidebar-link-title">{{ item.title }}</span>
                      </nuxt-link>
                      <v-divider v-if="index < highlight.length - 1" class="sidebar-item-divider"></v-divider>
                    </div>
                  </v-skeleton-loader>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    props: {

    },
    data () {
      return {
        list: [],
        highlight: [],
        hoax: [],
        process: {
          load: false,
          category: false
        },
        message: {
          success: '',
          error: ''
        },
      }
    },
    head () {


    },
    components: {

    },
    watch: {

    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.member.auth.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      sidebarPalette () {
        const primary = this.set_color || '#B71C1C'
        return {
          '--sidebar-surface': '#FFFFFF',
          '--sidebar-text': '#2D2D2D',
          '--sidebar-text-muted': '#6B6B6B',
          '--sidebar-border': '#E8E4E0',
          '--sidebar-primary': primary,
          '--sidebar-primary-soft': primary + '14',
          '--sidebar-shadow': '0 2px 12px rgba(45, 45, 45, 0.06)'
        }
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      voiceHover (item) {
        responsiveVoice.cancel(); // Cancel anything else that may currently be speaking
        responsiveVoice.speak(item, 'Indonesian Female');
      },
      async fetch () {
        this.process.load = true
        const params = {
          limit: 5,
          category_par_id: '1',
          'category_id[nin]': '2,15,16',
          sort: '-publish_datetime',
        }
        try {
          const res = await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
          if (res.status === 200) {
            this.list = res.results.data || []
          }
          this.fetchHoax()
        } catch (e) {
          this.process.load = false
        }
      },
      async fetchHoax () {
        this.process.load = true
        const params = {
          limit: 5,
          category_par_id: '17',
          sort: '-publish_datetime',
        }
        try {
          const res = await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
          if (res.status === 200) {
            this.hoax = res.results.data || []
          }
          this.fetchHighlight()
        } catch (e) {
          this.process.load = false
        }
      },
      async fetchHighlight () {
        this.process.load = true
        const params = {
          limit: 5,
          is_highlight: '1',
          category_par_id: '1',
          'category_id[nin]': '2,15,16',
          sort: '-publish_datetime',
        }
        try {
          const res = await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
          if (res.status === 200) {
            this.highlight = res.results.data || []
          }
        } catch (e) {
          // ignore
        } finally {
          this.process.load = false
        }
      },
      toDetailBerita(item) {
        this.$router.push(`/berita/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
      },
    }
  }
</script>

<style scoped>
.sidebar-modern {
  min-width: 0;
}

.sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.sidebar-widget {
  border-radius: 12px;
  overflow: hidden;
}

.sidebar-card {
  border-radius: 12px !important;
  background: var(--sidebar-surface) !important;
  border: 1px solid var(--sidebar-border);
  box-shadow: var(--sidebar-shadow);
}

.sidebar-card-text {
  padding: 1rem 1.25rem !important;
}

.sidebar-widget-title {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  display: flex;
  align-items: center;
}

.sidebar-divider {
  border-color: var(--sidebar-border) !important;
}

.sidebar-link {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.625rem 0.75rem;
  margin: 0 -0.75rem;
  border-radius: 8px;
  text-decoration: none;
  color: var(--sidebar-text);
  transition: background 0.2s ease, color 0.2s ease;
}

.sidebar-link:hover {
  background: var(--sidebar-primary-soft);
  color: var(--sidebar-primary);
}

.sidebar-link-num {
  flex-shrink: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--sidebar-primary);
  min-width: 1.25rem;
}

.sidebar-link-title {
  font-size: 0.875rem;
  line-height: 1.4;
  flex: 1;
  min-width: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sidebar-item-divider {
  border-color: var(--sidebar-border) !important;
  margin: 0 !important;
  opacity: 0.8;
}
</style>
